import _ from "underscore";
import qs from "qs";
import axios from "axios";
import store from "../store";
import FileSaver from "file-saver";
import contentDisposition from "content-disposition";

const ERRORS = {};
["GENERIC", "AUTH", "API"].forEach(key => (ERRORS[key] = key));
export { ERRORS };

export class ErrorWrapper extends Error {
  constructor(code, message) {
    super();
    this.name = "ErrorWrapper";
    this.code = code;
    this.message = message;
  }
}

function trimUrl(url) {
  if (url.indexOf("http") !== 0)
    url = `${window.document.location.origin}${url}`;
  const x = url.indexOf("/rest");
  return x >= 0 ? url.substr(0, x + 5) : url;
}

export function toError(err) {
  if (err.isAxiosError) {
    if (err.response && err.response.status === 401) {
      return new ErrorWrapper(
        ERRORS.AUTH,
        "Неверное имя пользователя или пароль"
      );
    } else if (err.response && err.response.status === 404) {
      return new ErrorWrapper(
        ERRORS.API,
        `Не удалось подключиться к серверу: ${trimUrl(err.config.url)}`
      );
    } else if (err.response && err.response.data && err.response.data.message) {
      return new ErrorWrapper(ERRORS.API, err.response.data.message);
    } else if (err.response && err.response.data) {
      if (
        err.response &&
        err.response.headers &&
        err.response.headers["content-type"] &&
        `${err.response.headers["content-type"]}`.startsWith("text/html")
      ) {
        const tempDiv = window.document.createElement("div");
        tempDiv.innerHTML = err.response.data;
        const message = tempDiv.innerText;
        tempDiv.remove();
        return new ErrorWrapper(ERRORS.API, message);
      } else {
        return new ErrorWrapper(ERRORS.API, err.response.data);
      }
    } else {
      return new ErrorWrapper(ERRORS.API, `Не удалось подключиться к серверу: ${trimUrl(err.config.url)}`);
    }
  } else {
    return new ErrorWrapper(ERRORS.GENERIC, err.message);
  }
}

export function prepareParams(query) {
  const data = {};
  if (query.page) {
    data.page = query.page;
  }
  if (query.sort) {
    data.sort = query.sort;
  }
  if (query.filter) {
    if (_.isArray(query.filter) && query.filter.length === 1) {
      data.filter = query.filter[0];
    } else {
      data.filter = query.filter;
    }
  }
  if (query.filterJson) {
    data["filter-json"] = JSON.stringify(query.filterJson);
  }

  return data;
}

export async function sleep(ms) {
  return new Promise(resolve => setTimeout(() => resolve(), ms));
}

export async function getConfig() {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.BASE_URL || "/"}config.json`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(toError(err)));
  });
}

export async function auth(username, password) {
  const API_URL = store.getters.apiPath;
  return new Promise(async (resolve, reject) => {
    //await sleep(5000);
    axios
      .post(
        `${API_URL}/auth/`,
        {},
        {
          auth: {
            username,
            password
          }
        }
      )
      .then(resp => {
        store.commit("setToken", `Basic ${btoa(username + ':' + password)}`);
        resolve(resp.data);
      })
      .catch(err => reject(toError(err)));
  });
}

export async function get(url, params) {
  const API_URL = store.getters.apiPath;
  return new Promise((resolve, reject) => {
    const token = store.getters.token;
    if (!token) {
      reject(new ErrorWrapper(ERRORS.AUTH, "Пользователь не авторизован"));
    }
    const options = { headers: { Authorization: token } };
    if (params) {
      options.params = params;
      options.paramsSerializer = function(params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      };
    }
    axios
      .get(`${API_URL}${url}`, options)
      .then(resp => resolve(resp.data))
      .catch(err => reject(toError(err)));
  });
}

export async function put(url, data, contentType) {
  const API_URL = store.getters.apiPath;
  return new Promise((resolve, reject) => {
    const token = store.getters.token;
    if (!token) {
      reject(new ErrorWrapper(ERRORS.AUTH, "Пользователь не авторизован"));
    }
    const options = { headers: { Authorization: token } };
    if (contentType) {
      options.headers["Content-Type"] = contentType;
    }
    axios
      .put(`${API_URL}${url}`, data, options)
      .then(resp => resolve(resp.data))
      .catch(err => reject(toError(err)));
  });
}

export async function post(url, data, contentType) {
  const API_URL = store.getters.apiPath;
  return new Promise((resolve, reject) => {
    const token = store.getters.token;
    if (!token) {
      reject(new ErrorWrapper(ERRORS.AUTH, "Пользователь не авторизован"));
    }
    const options = { headers: { Authorization: token } };
    if (contentType) {
      options.headers["Content-Type"] = contentType;
    }
    axios
      .post(`${API_URL}${url}`, data, options)
      .then(resp => resolve(resp.data))
      .catch(err => reject(toError(err)));
  });
}

export async function postForm(url, formData) {
  const API_URL = store.getters.apiPath;
  return new Promise((resolve, reject) => {
    const token = store.getters.token;
    if (!token) {
      reject(new ErrorWrapper(ERRORS.AUTH, "Пользователь не авторизован"));
    }
    const options = {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data"
      }
    };
    axios
      .post(`${API_URL}${url}`, formData, options)
      .then(resp => resolve(resp.data))
      .catch(err => reject(toError(err)));
  });
}

export async function del(url) {
  const API_URL = store.getters.apiPath;
  return new Promise((resolve, reject) => {
    const token = store.getters.token;
    if (!token) {
      reject(new ErrorWrapper(ERRORS.AUTH, "Пользователь не авторизован"));
    }
    axios
      .delete(`${API_URL}${url}`, { headers: { Authorization: token } })
      .then(resp => resolve(resp.data))
      .catch(err => reject(toError(err)));
  });
}
/*
export async function upload(file) {
  const API_URL = store.getters.apiPath;
  return new Promise((resolve, reject) => {
    const token = store.getters.token;
    if (!token) {
      reject(new ErrorWrapper(ERRORS.AUTH, "Пользователь не авторизован"));
    }
    const data = new FormData();
    data.set("file", file);
    axios({
      method: "post",
      url: `${API_URL}/fct-data-loads/upload`,
      data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: token,
        "Content-Disposition": contentDisposition(file.name)
      },
      timeout: 200000
    })
      .then(resp => resolve(resp.data))
      .catch(err => reject(toError(err)));
  });
}
*/
export async function download(url, filename) {
  const API_URL = store.getters.apiPath;
  return new Promise((resolve, reject) => {
    const token = store.getters.token;
    if (!token) {
      reject(new ErrorWrapper(ERRORS.AUTH, "Пользователь не авторизован"));
    }

    const xhr = new XMLHttpRequest();
    xhr.open("GET", `${API_URL}${url}`, true);
    xhr.responseType = "blob";
    xhr.setRequestHeader("Authorization", token);

    xhr.onload = function(e) {
      try {
        if (this.status === 200) {
          if (!filename) {
            const disposition = contentDisposition.parse(
              this.getResponseHeader("Content-Disposition")
            );
            filename = disposition.parameters.filename;
          }
          FileSaver.saveAs(e.target.response, filename);
          resolve();
        } else {
          const reader = new FileReader();
          reader.onload = function() {
            try {
              reject(toError(JSON.parse(reader.result)));
            } catch (err) {
              reject(toError(new Error(reader.result)));
            }
          };
          reader.readAsText(this.response.valueOf());
        }
      } catch (error) {
        reject(error);
      }
    };

    xhr.send();
  });
}
